import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraDataTable } from '@mono/ui-components/captains';
import { SpecraBadge, SpecraButton, SpecraLink, SpecraText } from '@mono/ui-components/ensigns';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { renderRouterLink } from '../../../lib/renderRouterLink';
import { HOME_STATUS } from './rfiHomeModel';
const T = Testids.rfiWorkspace;
const FIRST = 8;
function lastQuestion(rfiId) {
    try {
        return window.localStorage.getItem(`rfi.${rfiId}.lastQuestion`) ?? '';
    } catch  {
        return '';
    }
}
/** "Questions, as {agency} wrote them" (WRT-06 layout item 5): first 8, then "show all". */ // specra-allow local-composite: the WRT-06 question columns over SpecraDataTable, no restyle
export function RfiQuestionsTable({ base, rfiId, rows }) {
    const [all, setAll] = useState(false);
    const navigate = useNavigate();
    const selected = lastQuestion(rfiId);
    const shown = all ? rows : rows.slice(0, FIRST);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-[var(--space-2)]",
        children: [
            /*#__PURE__*/ _jsx(SpecraDataTable, {
                columns: [
                    {
                        id: 'n',
                        header: '#',
                        align: 'right',
                        width: 'var(--space-8)',
                        cell: (r)=>/*#__PURE__*/ _jsx(SpecraText, {
                                size: "meta",
                                tone: "muted",
                                children: r.number
                            })
                    },
                    {
                        id: 'question',
                        header: 'Question',
                        cell: (r)=>/*#__PURE__*/ _jsx(SpecraLink, {
                                href: `${base}/questions/${r.sectionId}`,
                                renderLink: renderRouterLink,
                                children: r.questionText || `Question ${r.number}`
                            })
                    },
                    {
                        id: 'owner',
                        header: 'Owner',
                        cell: (r)=>r.ownerUserId ? /*#__PURE__*/ _jsx(SpecraText, {
                                size: "body-ui",
                                children: r.ownerName || r.ownerUserId
                            }) : /*#__PURE__*/ _jsx(SpecraText, {
                                className: "font-medium",
                                size: "body-ui",
                                tone: "danger",
                                children: "No owner"
                            })
                    },
                    {
                        id: 'status',
                        header: 'Status',
                        cell: (r)=>{
                            const s = HOME_STATUS[r.status] ?? HOME_STATUS.not_started;
                            return /*#__PURE__*/ _jsx(SpecraBadge, {
                                variant: s.variant,
                                children: s.label
                            });
                        }
                    },
                    {
                        id: 'starts',
                        header: 'Starts from',
                        cell: (r)=>/*#__PURE__*/ _jsx(SpecraText, {
                                size: "meta",
                                tone: "muted",
                                children: r.startsFromLabel || '—'
                            })
                    }
                ],
                getRowId: (r)=>r.sectionId,
                getRowLabel: (r)=>`Question ${r.number}`,
                isRowSelected: (r)=>r.sectionId === selected,
                onRowClick: (r)=>navigate(`${base}/questions/${r.sectionId}`),
                rowTestId: T.questionRow,
                rows: shown,
                testId: T.questionsTable,
                emptyTitle: "No questions yet",
                emptyDescription: "Questions appear once the RFI's documents are read."
            }),
            !all && rows.length > FIRST ? /*#__PURE__*/ _jsxs(SpecraText, {
                size: "body-ui",
                tone: "muted",
                children: [
                    rows.length - FIRST,
                    " more questions ·",
                    ' ',
                    /*#__PURE__*/ _jsxs(SpecraButton, {
                        "data-testid": T.showAllQuestions,
                        onClick: ()=>setAll(true),
                        size: "inline",
                        variant: "link",
                        children: [
                            "show all ",
                            rows.length
                        ]
                    })
                ]
            }) : null
        ]
    });
}
